import moment from 'moment';
import { useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';

interface ParamProps {
  warehouseId?: string;
}

export default function InventoryReports(): JSX.Element {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const warehouseId = queryParams.get('warehouseId');
  const [fromDate, setFromDate] = useState<Date>(moment().subtract(1, 'month').toDate());
  const [toDate, setToDate] = useState<Date>(moment().toDate());

  const appendWarehouseId = (url: string): string => {
    if (warehouseId != null && warehouseId !== undefined) {
      return `${url}?warehouseId=${warehouseId}`;
    }
    return url;
  };

  return (
    <>
      <TitleComponent title="Inventory Reports" />
      <WhitePad isFluid>
        <ul>
          <li>
            <Link to={appendWarehouseId('/inventory/reports/incoming')}>Incoming</Link>
          </li>
          <li>
            <Link to={appendWarehouseId('/inventory/reports/outgoing')}>Outgoing</Link>
          </li>
        </ul>
      </WhitePad>
    </>
  );
}